import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import gsap from "gsap";
// import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);
import { getCoords, getViewport } from "../utils/utils";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.detail = this.ref.detail[0];
    this.fnResize = this.calculate.bind(this);

    this.calculate();
    Channels.on("window::smartresize", this.fnResize);
  }

  calculate() {
    if (Env.mobileCSS == false) {
      gsap.delayedCall(0.25, () => {
        gsap.set(this.DOM.detail, { paddingTop: 0 });
        const coord = getCoords(this.DOM.detail);
        const viewport = getViewport();
        let setPaddingTop = (viewport.height - (coord.height - 100)) / 2;
        // setPaddingTop -= 100;
        if (setPaddingTop < 80) {
          setPaddingTop = 20;
        }
        gsap.set(this.DOM.detail, { paddingTop: setPaddingTop });
      });
    }
  }

  unmount() {
    Channels.removeListener("window::smartresize", this.fnResize);
  }
}
